export const getStatusColor = (
  status: string
): "default" | "primary" | "secondary" | "error" | "warning" | "info" | "success" => {
  switch (status) {
    case 'Approved':
      return 'success';
    case 'Pending Manager Approval':
      return 'warning';
    case 'Pending HR Approval':
      return 'info';
    case 'Draft':
      return 'default';
    case 'Rejected':
      return 'error';
    default:
      return 'default';
  }
};

export const getStatusLabel = (status: string): string => {
  return status;
};

export const getStatusIcon = (status: string): string => {
  switch (status) {
    case 'Approved':
      return '✓';
    case 'Pending Manager Approval':
      return '⏳';
    case 'Pending HR Approval':
      return '⏳';
    case 'Draft':
      return '📝';
    case 'Rejected':
      return '✗';
    default:
      return '';
  }
};
